export default __webpack_public_path__ + "static/media/company4.915aa595.png";